import { Action, ActionType, PlanType } from "../../@types";
import {
  CoverageSelectorSelectedValues,
  CoverageType,
} from "../../components/CoverageSelector/types";
import Routes from "../../app/routes";

const planTypeMap: Record<CoverageType, PlanType | undefined> = {
  [CoverageType.MAPD]: PlanType.MAPD,
  [CoverageType.PDP]: PlanType.PDP,
  [CoverageType.PDPAndMedigap]: PlanType.PDP,
  [CoverageType.MedigapPolicy]: undefined,
  [CoverageType.learnMore]: undefined,
};

export const destinationMap: Record<CoverageType, string> = {
  [CoverageType.MAPD]: Routes.lisQuestions,
  [CoverageType.PDP]: Routes.lisQuestions,
  [CoverageType.PDPAndMedigap]: Routes.lisQuestions,
  [CoverageType.MedigapPolicy]: Routes.medigap.landingPage,
  [CoverageType.learnMore]: Routes.coverageWizard.options,
};

export const updateStates = (
  coverageSelectorValues: CoverageSelectorSelectedValues,
  dispatch: React.Dispatch<Action>
): void => {
  dispatch({
    type: ActionType.UPDATE_VIEW_MEDIGAP,
    payload: coverageSelectorValues.coverageType === CoverageType.PDPAndMedigap,
  });
  dispatch({
    type: ActionType.UPDATE_YEAR,
    payload: coverageSelectorValues.coverageYear.toString(),
  });
  dispatch({
    type: ActionType.UPDATE_COUNTY,
    payload: coverageSelectorValues.county,
  });
  dispatch({
    type: ActionType.UPDATE_FIPS,
    payload: coverageSelectorValues.county?.fips,
  });
  dispatch({
    type: ActionType.UPDATE_ZIPCODE,
    payload: coverageSelectorValues.zipcode,
  });
  dispatch({
    type: ActionType.UPDATE_PHARMACY_ADDRESS,
    payload: "",
  });

  if (coverageSelectorValues.coverageType) {
    const planType = planTypeMap[coverageSelectorValues.coverageType];
    if (planType) {
      dispatch({
        type: ActionType.UPDATE_PLAN_TYPE,
        payload: planType,
      });
    }
  }
};
